import { TaskItemForSchedule } from '@demind-inc/core';
import { getDueDateYYYYMMDD } from '../../../../helpers';

export interface ValidationError {
  section: 'name' | 'duration' | 'labels';
  errorKey: string;
}

export const validateScheduledTask = (
  task: TaskItemForSchedule,
  targetDate: string
): ValidationError[] => {
  const errors: ValidationError[] = [];

  // Validate name
  if (!task.name || task.name.trim() === '') {
    errors.push({
      section: 'name',
      errorKey: 'task.scheduler.validation.taskNameRequired',
    });
  }

  // Validate duration
  if (!task.duration || task.duration.amount <= 0) {
    errors.push({
      section: 'duration',
      errorKey: 'task.scheduler.validation.durationGreaterThanZero',
    });
  }

  return errors;
};

export const getTaskToBeScheduled = (task: TaskItemForSchedule, targetDate: string) => {
  const duration = task.duration?.unit === 'minute' ? task.duration?.amount : undefined;
  const hasScheduledAlready =
    task.addedToCalendar && getDueDateYYYYMMDD(task.dueDateTime) === targetDate;
  const canTaskBeScheduled = !hasScheduledAlready;

  return { duration, canTaskBeScheduled, hasScheduledAlready };
};
